/**
 * sn-geschenk — Geschenk-Automatik + Stueckzahl-Logik fuer den Warenkorb (Horizon). Markup: snippets/sn-geschenk.liquid,
 * snippets/cart-products.liquid (Stepper je Produkt, Hinweiszeile).
 *
 * Geschenkstufen (21.10.2026, Ken): ab 49 € Warenwert EIN Gratis-Geschenk, ab 85 € ZWEI. Warenwert = alle Zeilen ohne
 * Geschenkzeilen, vor Rabattcodes (Codes sind Bestell-Rabatte und wirken erst danach).
 * Shopify: zwei automatische Rabatte „Kaufe X, erhalte Y“ – „Gratis-Geschenk ab 49 €“ (1 Dose gratis) und „2 Gratis-
 * Geschenke ab 85 €“ (2 Dosen gratis), Kollektion „Steuersatz“, dieselben Geschenk-Varianten. Ohne Shopify Plus wirkt je
 * Bestellung nur EINE solche Aktion, Shopify nimmt die bessere (getestet 21.10.2026 mit Testcode).
 * Beide Titel muessen „Gratis-Geschenk“ enthalten – daran erkennt dieses Skript den Geschenk-Rabatt.
 *
 * - Jede Geschenkzeile traegt _sn_gift = '1' bzw. '2' (getrennte Zeilen, auch bei gleicher Sorte). Die Sorte je Zeile
 *   bleibt in der Sitzung gemerkt, auch wenn die Zeile zwischendurch rausfliegt.
 * - Unter einer Stufe fliegt die passende Geschenkzeile raus, darueber kommt sie dazu.
 * - Wer ein Geschenk per X entfernt, bekommt es in dieser Sitzung nicht automatisch zurueck, bis der Warenwert unter die
 *   Stufe faellt. „+ Gratis dazulegen“ holt es zurueck.
 * - Shopify schenkt immer die GUENSTIGSTEN passenden Dosen. Liegt eine bezahlte Geschenk-Sorte im Korb, die billiger ist
 *   als das gewaehlte Geschenk, ist sie gratis und die Geschenkzeile kostet. Der Warenwert zaehlt deshalb mit dem Preis VOR
 *   dem Geschenk-Rabatt, sonst springt das Geschenk hin und her (Befund 21.10.2026).
 * - Sicherheitsnetz: Macht Shopify weniger Dosen gratis, als Geschenkzeilen im Korb liegen (Rabatt aus, ein Code verdraengt
 *   die Aktion …), fliegen die nicht kostenlosen Geschenkzeilen wieder raus. Niemand bezahlt ein „Geschenk“.
 *
 * Stueckzahl (18.10.2026, Befund E11, Ken): Die Menge im Warenkorb zaehlt DOSEN bzw. SETS, nicht Pakete.
 * - Je Produkt EIN Stepper (erste Zeile des Produkts, cart-products.liquid zeigt dort die Gesamtzahl). Plus/Minus
 *   aendert die Gesamtzahl um 1; der Korb wird danach in die guenstigste Paketkombination zerlegt
 *   (groesstes Paket zuerst, Rest kleiner): 2 Sets → 3 Sets, 3 Dosen → 3 Dosen + 1 Dose, 5 → 5er, 6 → 5er + 1.
 *   Horizons eigene Mengenaenderung wird fuer solche Zeilen abgefangen (sonst 2 × „2 Sets“ = 4 Sets, Befund 18.10.).
 * - Dieselbe Zerlegung laeuft nach jeder Korb-Aenderung (z. B. zweimal „1 Set“ von der Produktseite → „2 Sets“).
 * - Nach einer Umstellung kurzer Hinweis im Einschub („… du sparst 8,00 €“).
 *
 * Alle Korb-Aenderungen laufen nacheinander durch eine Warteschlange (reihe); eine angestossene Pruefung geht nie
 * verloren. Wir aendern den Korb per AJAX-API und melden das Horizon ueber dasselbe Ereignis wie der Kaufen-Knopf
 * (shopify:cart:lines-update); Horizon rendert Einschub, Warenkorbseite und Zaehler dann selbst neu.
 */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

/** Geschenkwahl im Warenkorb, Reihenfolge = Vorschlag. Jede Variante muss in BEIDEN Rabattaktionen unter „Kunde erhaelt“ stehen. */
const GIFTS = [39859707805872, 39859707936944, 46870515974475, 46870470295883, 39859719766192, 39859713441968];
/** Warenwert in Cent fuer das 1. und das 2. Geschenk – muss zu den Rabattaktionen passen. */
const STUFEN = [4900, 8500];
const AUS_KEY = 'snGiftAus'; // per X entfernte Geschenke: {n: Anzahl, s: Stufe beim letzten Pruefen}
const ALT_OFF_KEY = 'snGiftOff'; // Merker der alten Fassung (eine Stufe), wird einmal uebernommen
const WAHL_KEY = 'snGiftWahl'; // gewaehlte Sorte je Geschenkzeile {"1": id, "2": id}
const NETZ_KEY = 'snGiftNetz'; // Sicherheitsnetz {max, sig}: so viele Geschenke macht Shopify fuer diesen Korb gratis
const MAX_EINHEITEN = 99;

/** Alle Korb-Aenderungen nacheinander, nie parallel. */
let kette = Promise.resolve();
let pruefungAngemeldet = false;
function reihe(fn) {
  const p = kette.then(fn, fn);
  kette = p.catch(() => {});
  return p;
}
function pruefungAnstossen() {
  if (pruefungAngemeldet) return;
  pruefungAngemeldet = true;
  reihe(async () => {
    pruefungAngemeldet = false;
    await check();
  });
}

const lies = (k) => {
  try {
    return sessionStorage.getItem(k);
  } catch {
    return null;
  }
};
const schreib = (k, v) => {
  try {
    v == null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v);
  } catch {}
};
const jsonLesen = (k) => {
  try {
    const v = JSON.parse(lies(k) || 'null');
    return v && typeof v === 'object' ? v : null;
  } catch {
    return null;
  }
};

const isGift = (item) => Boolean(item && item.properties && item.properties._sn_gift);
/** Geschenkzeile 1 oder 2 (alte Zeilen ohne Nummer zaehlen als 1). */
const slot = (item) => (String(item?.properties?._sn_gift) === '2' ? 2 : 1);
/** „3 Dosen“ → 3, „2 Sets“ → 2, „1 Dose“ → 1, „Default Title“ → 0 (kein Paketprodukt). */
const einheiten = (t) => parseInt(String(t || '').trim(), 10) || 0;
const istPaketZeile = (item) => !isGift(item) && !item.selling_plan_allocation && einheiten(item.variant_title) > 0;

/** Alle Warenkorb-Abschnitte auf der Seite (Einschub + ggf. Warenkorbseite). */
function sectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.add(el.dataset.sectionId);
  });
  return Array.from(ids);
}

function eventTarget() {
  return document.querySelector('theme-drawer#cart-drawer') || document;
}

async function getCart() {
  const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' });
  return res.json();
}

/**
 * Fuehrt eine Korb-Aenderung aus und laesst Horizon neu rendern.
 * @param {'add'|'change'|'update'} kind
 * @param {object} body
 * @param {Array<{merchandiseId: string, quantity: number}>} lines
 */
async function mutate(kind, body, lines) {
  const sections = sectionIds();
  const deferred = CartLinesUpdateEvent.createPromise();
  eventTarget().dispatchEvent(
    new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines, promise: deferred.promise })
  );
  try {
    const url = `${window.Shopify?.routes?.root || '/'}cart/${kind}.js`;
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(sections.length ? { ...body, sections: sections.join(','), sections_url: location.pathname } : body),
    });
    const data = await res.json();
    const cart = await getCart();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { sections: data.sections, items: cart.items, source: 'sn-geschenk', didError: !res.ok },
    });
    return cart;
  } catch (error) {
    deferred.resolve({ detail: { didError: true, source: 'sn-geschenk' } });
    throw error;
  }
}

/* ---------- Geschenk: rechnen ---------- */

/** Rabatt der Geschenk-Aktion auf einer Zeile in Cent, erkannt am Titel „Gratis-Geschenk …“. */
const istGeschenkRabatt = (a) => /gratis-geschenk/i.test(String(a?.discount_application?.title || ''));
const geschenkRabatt = (item) =>
  (item.line_level_discount_allocations || []).reduce((s, a) => s + (istGeschenkRabatt(a) ? Number(a.amount) || 0 : 0), 0);

/** Warenwert ohne Geschenkzeilen, vor Codes. Der Geschenk-Rabatt auf bezahlten Zeilen zaehlt nicht ab (siehe oben). */
function warenwert(cart) {
  let summe = 0;
  for (const item of cart.items || []) {
    if (!isGift(item)) summe += (Number(item.final_line_price) || 0) + geschenkRabatt(item);
  }
  return summe;
}
const stufeFuer = (wert) => (wert >= STUFEN[1] ? 2 : wert >= STUFEN[0] ? 1 : 0);

/** Wie viele Dosen macht Shopify gerade ueber die Geschenk-Aktion gratis (alle Zeilen zusammen)? */
function freieDosen(cart) {
  let n = 0;
  for (const item of cart.items || []) {
    const r = geschenkRabatt(item);
    const preis = Number(item.original_price) || Number(item.price) || 0;
    if (r > 0 && preis > 0) n += Math.round(r / preis);
  }
  return n;
}

/** Kennung fuer das Sicherheitsnetz: gilt nur, solange Stufe und Codes gleich bleiben. */
const signatur = (cart, stufe) =>
  stufe + '|' + (cart.discount_codes || []).map((d) => `${d.code}${d.applicable ? '+' : '-'}`).sort().join(',');
function netzMax(sig) {
  const m = jsonLesen(NETZ_KEY);
  return m && m.sig === sig && Number.isFinite(m.max) ? m.max : 2;
}
/** Sicherheitsnetz aktiv → „+ Gratis dazulegen“ nicht anbieten (CSS in sn-warenkorb.css). */
function netzHinweis(an) {
  document.documentElement.classList.toggle('sn-geschenk-netz', Boolean(an));
}

/** Per X abgelehnte Geschenke. Faellt die Stufe, verfallen entsprechend viele Ablehnungen (wie bisher unter 49 €). */
function abgelehnt(stufe) {
  let a = jsonLesen(AUS_KEY);
  if (!a) {
    a = { n: lies(ALT_OFF_KEY) === '1' ? 1 : 0, s: stufe };
    schreib(ALT_OFF_KEY, null);
  }
  let n = Math.max(0, Math.min(2, Number(a.n) || 0));
  const s = Number(a.s) || 0;
  if (stufe < s) n = Math.max(0, n - (s - stufe));
  if (n !== a.n || stufe !== s) schreib(AUS_KEY, JSON.stringify({ n, s: stufe }));
  return n;
}
function ablehnungAendern(delta) {
  const a = jsonLesen(AUS_KEY) || { n: 0, s: 0 };
  a.n = Math.max(0, Math.min(2, (Number(a.n) || 0) + delta));
  schreib(AUS_KEY, JSON.stringify(a));
}

/** Sorte fuer Geschenkzeile nr: gemerkte Wahl, sonst die erste, die weder bezahlt noch schon geschenkt im Korb liegt. */
function wahlFuer(nr, cart, neu) {
  const gemerkt = Number((jsonLesen(WAHL_KEY) || {})[nr]);
  if (GIFTS.includes(gemerkt)) return gemerkt;
  const bezahlt = new Set((cart.items || []).filter((i) => !isGift(i)).map((i) => i.variant_id));
  const geschenkt = new Set([...(cart.items || []).filter(isGift).map((i) => i.variant_id), ...neu.map((i) => i.id)]);
  return GIFTS.find((id) => !bezahlt.has(id) && !geschenkt.has(id)) ?? GIFTS.find((id) => !geschenkt.has(id)) ?? GIFTS[0];
}
function wahlMerken(nr, id) {
  const w = jsonLesen(WAHL_KEY) || {};
  w[nr] = id;
  schreib(WAHL_KEY, JSON.stringify(w));
}

/* ---------- Stueckzahl: Pakete je Produkt ---------- */

/** Paketstufen eines Produkts aus /products/<handle>.js (einmal je Seite geladen). */
const stufenCache = new Map();
async function stufen(handle) {
  if (stufenCache.has(handle)) return stufenCache.get(handle);
  const p = (async () => {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) return [];
    const produkt = await res.json();
    return (produkt.variants || [])
      .map((v) => ({ id: v.id, n: einheiten(v.title), da: v.available, preis: Number(v.price) || 0, titel: v.title }))
      .filter((v) => v.n > 0 && v.da)
      .sort((a, b) => b.n - a.n);
  })();
  stufenCache.set(handle, p);
  return p;
}

/** Zerlegt eine Stueckzahl in Pakete: groesstes zuerst, Rest kleiner. null, wenn es nicht aufgeht (kein 1er verfuegbar). */
function zerlege(anzahl, liste) {
  const teile = [];
  let rest = anzahl;
  for (const s of liste) {
    const k = Math.floor(rest / s.n);
    if (k > 0) {
      teile.push({ id: s.id, n: s.n, qty: k, titel: s.titel, preis: s.preis });
      rest -= k * s.n;
    }
  }
  return rest === 0 ? teile : null;
}

const einheitWort = (titel, anzahl, en) => {
  const set = /set/i.test(String(titel || ''));
  if (en) return set ? (anzahl === 1 ? 'set' : 'sets') : (anzahl === 1 ? 'tub' : 'tubs');
  return set ? (anzahl === 1 ? 'Set' : 'Sets') : (anzahl === 1 ? 'Dose' : 'Dosen');
};

/**
 * Bringt die Paketzeilen jedes Produkts in die guenstigste Kombination. ziele: { product_id: gewuenschte Stueckzahl }
 * (vom Stepper); ohne Ziel bleibt die Stueckzahl, nur die Aufteilung wird bereinigt (z. B. 2 × „1 Set“ → „2 Sets“).
 * @returns {Promise<boolean>} true, wenn der Korb geaendert wurde
 */
async function normalisieren(cart, ziele = {}) {
  const gruppen = new Map();
  for (const item of cart.items || []) {
    if (!istPaketZeile(item)) continue;
    const g = gruppen.get(item.product_id) || { handle: item.handle, zeilen: [], anzahl: 0, titel: item.variant_title };
    g.zeilen.push(item);
    g.anzahl += einheiten(item.variant_title) * item.quantity;
    gruppen.set(item.product_id, g);
  }
  let geaendert = false;
  for (const [pid, g] of gruppen) {
    const ziel = ziele[pid] != null ? Math.max(0, Math.min(MAX_EINHEITEN, ziele[pid])) : g.anzahl;
    const liste = await stufen(g.handle);
    if (!liste.length) continue;
    const soll = ziel > 0 ? zerlege(ziel, liste) : [];
    if (soll === null) continue;
    // Ist-Zustand schon richtig? (eine Zeile je Paketstufe, richtige Mengen)
    const sollMap = new Map(soll.map((s) => [s.id, s.qty]));
    let gleich = g.zeilen.length === soll.length;
    if (gleich) for (const z of g.zeilen) if (sollMap.get(z.variant_id) !== z.quantity) { gleich = false; break; }
    if (gleich) continue;
    const updates = {};
    const belegt = new Set();
    for (const z of g.zeilen) {
      const q = sollMap.get(z.variant_id);
      if (q != null && !belegt.has(z.variant_id)) { updates[z.key] = q; belegt.add(z.variant_id); }
      else updates[z.key] = 0;
    }
    for (const [id, q] of sollMap) if (!belegt.has(id)) updates[id] = q;
    await mutate('update', { updates }, soll.map((s) => ({ merchandiseId: String(s.id), quantity: s.qty })));
    geaendert = true;
    if (ziel > 0) zeigePaketHinweis(ziel, soll, liste, g.titel);
  }
  return geaendert;
}

/* ---------- Hinweis im Einschub ---------- */

/** Kurzer Hinweis oben im Einschub (9 s). Horizon zeichnet den ganzen Einschub-Abschnitt nach jeder Korb-Aenderung neu
 *  (morphSection) und wirft fremde Elemente dabei raus – ein Beobachter setzt den Hinweis so lange wieder ein. */
let paketToast = null;
let toastWaechter = null;
function toastEinsetzen() {
  if (!paketToast) return;
  if (Date.now() > paketToast.until) {
    paketToast = null;
    document.querySelectorAll('.sn-paket-toast').forEach((e) => e.remove());
    return;
  }
  if (document.querySelector('.sn-paket-toast')) return;
  const host = document.querySelector('theme-drawer#cart-drawer .cart-drawer__items, theme-drawer#cart-drawer cart-items-component, cart-items-component');
  if (!host) return;
  const el = document.createElement('p');
  el.className = 'sn-paket-toast';
  el.setAttribute('role', 'status');
  el.textContent = paketToast.text;
  host.prepend(el);
  setTimeout(toastEinsetzen, paketToast.until - Date.now() + 50);
}
function zeigePaketHinweis(anzahl, soll, liste, titel) {
  const en = (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const einzel = liste.find((s) => s.n === 1);
  const paketPreis = soll.reduce((sum, s) => sum + s.qty * s.preis, 0);
  const ersparnis = einzel ? anzahl * einzel.preis - paketPreis : 0;
  if (!soll.some((s) => s.n > 1) || ersparnis <= 0) return;
  let betrag = '';
  try {
    betrag = new Intl.NumberFormat(en ? 'en-GB' : 'de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(ersparnis / 100);
  } catch { betrag = (ersparnis / 100).toFixed(2) + ' €'; }
  const teile = soll.map((s) => (s.qty > 1 ? `${s.qty} × ` : '') + s.titel).join(' + ');
  const wort = einheitWort(titel, anzahl, en);
  const kopf = `${anzahl} ${wort}`;
  const als = soll.length === 1 && soll[0].qty === 1 ? '' : (en ? ` as ${teile}` : ` als ${teile}`);
  const text = en
    ? `${kopf}${als} – you save ${betrag} compared to single ${einheitWort(titel, 2, en)}.`
    : `${kopf}${als} – du sparst ${betrag} gegenüber ${/set/i.test(titel) ? 'einzelnen Sets' : 'Einzeldosen'}.`;
  document.querySelectorAll('.sn-paket-toast').forEach((e) => e.remove());
  paketToast = { text, until: Date.now() + 9000 };
  setTimeout(toastEinsetzen, 350);
  if (!toastWaechter) {
    toastWaechter = new MutationObserver(() => { if (paketToast) toastEinsetzen(); });
    toastWaechter.observe(document.getElementById('shopify-section-cart-drawer-section') || document.body, { childList: true, subtree: true });
  }
}

/* ---------- Geschenk: Korb anpassen ---------- */

/** Bringt die Geschenkzeilen auf die erlaubte Anzahl (0, 1 oder 2). Laeuft immer in der Warteschlange (reihe). */
async function geschenkPruefen(cart) {
  const stufe = stufeFuer(warenwert(cart));
  const ohneNetz = Math.max(0, stufe - abgelehnt(stufe));
  const erlaubt = Math.min(ohneNetz, netzMax(signatur(cart, stufe)));
  netzHinweis(erlaubt < ohneNetz);

  // 1. Zu viele Geschenkzeilen → die hoechsten Nummern raus; jede Geschenkzeile genau 1 Stueck
  const geschenke = (cart.items || []).filter(isGift).sort((a, b) => slot(a) - slot(b));
  const updates = {};
  geschenke.forEach((g, i) => {
    if (i >= erlaubt) updates[g.key] = 0;
    else if (g.quantity !== 1) updates[g.key] = 1;
  });
  let jetzt = cart;
  if (Object.keys(updates).length) {
    const lines = geschenke
      .filter((g) => g.key in updates)
      .map((g) => ({ merchandiseId: String(g.variant_id), quantity: updates[g.key] }));
    jetzt = await mutate('update', { updates }, lines);
  }

  // 2. Zu wenige → fehlende Nummern mit der gewaehlten Sorte dazulegen (eine Anfrage)
  const da = (jetzt.items || []).filter(isGift);
  const fehlen = erlaubt - da.length;
  if (fehlen > 0) {
    const belegt = new Set(da.map(slot));
    const items = [];
    for (let nr = 1; nr <= 2 && items.length < fehlen; nr++) {
      if (!belegt.has(nr)) items.push({ id: wahlFuer(nr, jetzt, items), quantity: 1, properties: { _sn_gift: String(nr) } });
    }
    if (items.length) {
      jetzt = await mutate('add', { items }, items.map((i) => ({ merchandiseId: String(i.id), quantity: 1 })));
    }
  }

  // 3. Kontrolle gegen Shopifys Rechnung
  await sicherheitsnetz(jetzt);
}

/** Liegen mehr Geschenkzeilen im Korb, als Shopify Dosen gratis macht, fliegen die nicht kostenlosen raus. */
async function sicherheitsnetz(cart) {
  const geschenke = (cart.items || []).filter(isGift);
  if (!geschenke.length) return;
  const zuViel = geschenke.length - freieDosen(cart);
  if (zuViel <= 0) return;
  const raus = geschenke
    .filter((g) => Number(g.final_line_price) > 0)
    .sort((a, b) => slot(b) - slot(a))
    .slice(0, zuViel);
  if (!raus.length) return;
  const stufe = stufeFuer(warenwert(cart));
  schreib(NETZ_KEY, JSON.stringify({ max: geschenke.length - raus.length, sig: signatur(cart, stufe) }));
  netzHinweis(true);
  const updates = {};
  raus.forEach((g) => (updates[g.key] = 0));
  await mutate('update', { updates }, raus.map((g) => ({ merchandiseId: String(g.variant_id), quantity: 0 })));
}

/** Laeuft immer innerhalb der Warteschlange (reihe). */
async function check(ziele) {
  try {
    let cart = await getCart();
    if (await normalisieren(cart, ziele || {})) cart = await getCart();
    await geschenkPruefen(cart);
  } catch {
    // Netzfehler: beim naechsten Korb-Ereignis erneut versuchen
  }
}

/** Geschenkzeile nr gegen die gewaehlte Sorte tauschen (laeuft in der Warteschlange). */
async function tausche(nr, id) {
  try {
    wahlMerken(nr, id);
    const cart = await getCart();
    const zeile = (cart.items || []).find((i) => isGift(i) && slot(i) === nr);
    if (!zeile || zeile.variant_id === id) return;
    await mutate('change', { id: zeile.key, quantity: 0 }, [{ merchandiseId: String(zeile.variant_id), quantity: 0 }]);
    const nachher = await mutate('add', { items: [{ id, quantity: 1, properties: { _sn_gift: String(nr) } }] }, [
      { merchandiseId: String(id), quantity: 1 },
    ]);
    await sicherheitsnetz(nachher);
  } catch {
    // naechste Korb-Aenderung prueft erneut
  }
}

/* ---------- Ereignisse ---------- */

// Stepper an einer Paketzeile im Korb: Horizons Mengenaenderung abfangen (sie wuerde nur die EINE Zeile
// vervielfachen, z. B. 2 × „2 Sets“), stattdessen Stueckzahl des Produkts setzen und neu zerlegen.
// Capture-Phase am document: laeuft vor Horizons cart-items-Komponente; stopPropagation haelt sie fern.
document.addEventListener(
  'quantity-selector:update',
  (event) => {
    const d = /** @type {any} */ (event).detail || {};
    if (!d.cartLine) return; // Produktseite → sn-kaufboxen
    const row = event.target instanceof Element ? event.target.closest('[data-key]') : null;
    if (!(row instanceof HTMLElement) || row.classList.contains('sn-geschenk-zeile')) return;
    const variante = row.querySelector('.cart-items__variants dd')?.textContent || '';
    if (!einheiten(variante)) return; // kein Paketprodukt → Horizon macht es selbst
    event.stopImmediatePropagation();
    const key = row.dataset.key;
    const ziel = Math.max(0, Math.min(MAX_EINHEITEN, Math.round(Number(d.quantity) || 0)));
    reihe(async () => {
      try {
        const cart = await getCart();
        const item = (cart.items || []).find((i) => i.key === key);
        if (!item || !istPaketZeile(item)) return;
        await check({ [item.product_id]: ziel });
      } catch {
        // naechste Korb-Aenderung prueft erneut
      }
    });
  },
  true
);

// Jede andere Korb-Aenderung (Kaufen-Knopf, Entfernen, Kaufleiste) -> danach pruefen. Nie verwerfen.
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const e = /** @type {any} */ (event);
  const done = e.promise && typeof e.promise.then === 'function' ? e.promise : Promise.resolve();
  done
    .then((result) => {
      if (result?.detail?.source === 'sn-geschenk') return;
      setTimeout(pruefungAnstossen, 120);
    })
    .catch(() => setTimeout(pruefungAnstossen, 400));
});

// Auswahl gewechselt: Bild sofort tauschen, Geschenkzeile ersetzen (eingereiht, geht nicht verloren).
document.addEventListener('change', (event) => {
  const sel = event.target;
  if (!(sel instanceof HTMLSelectElement) || !sel.matches('[data-sn-wahl-select]')) return;
  const id = Number(sel.value);
  if (!GIFTS.includes(id)) return;
  const nr = sel.dataset.snWahlNr === '2' ? 2 : 1;
  const box = sel.closest('[data-sn-wahl]');
  const img = box?.querySelector('[data-sn-wahl-bild]');
  const src = box?.getAttribute(`data-img-${id}`);
  if (img instanceof HTMLImageElement && src) img.src = src;
  reihe(() => tausche(nr, id));
});

// „+ Gratis dazulegen“ und X an einer Geschenkzeile
document.addEventListener(
  'click',
  (event) => {
    const t = event.target instanceof Element ? event.target : null;
    if (!t) return;
    if (t.closest('[data-sn-wahl-dazu]')) {
      ablehnungAendern(-1);
      reihe(async () => {
        try {
          await geschenkPruefen(await getCart());
        } catch {
          // naechste Korb-Aenderung prueft erneut
        }
      });
      return;
    }
    if (t.closest('.sn-geschenk-zeile .cart-items__remove')) ablehnungAendern(1);
  },
  true
);

// Beim Laden einmal pruefen (z. B. Korb aus einer frueheren Sitzung).
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pruefungAnstossen);
else pruefungAnstossen();

// Kassenfix 20.10.2026: Im Stueckzahl-Modus zeigt das Mengenfeld im Warenkorb Dosen bzw. Sets statt der Paketmenge
// (3er-Paket = „3“). Horizon schickt diese Felder (updates[]) beim Klick auf „Zur Kasse“ mit dem Formular an /cart,
// Shopify setzte damit die Paketmenge auf die Dosenzahl (aus einem 3er-Paket wurden drei 3er-Pakete).
// Alle Mengen aendern wir sofort per AJAX, der Korb ist also immer aktuell. Deshalb gehen beim Abschicken keine Mengenfelder mit.
{
  const istKorbFormular = (f) => {
    if (!(f instanceof HTMLFormElement)) return false;
    if (f.id === 'cart-form') return true;
    try {
      return /\/cart\/?$/.test(new URL(f.getAttribute('action') || '', location.href).pathname);
    } catch (e) {
      return false;
    }
  };
  const istMengenFeld = (name) => name === 'updates[]' || /^updates\[/.test(name || '');
  document.addEventListener(
    'submit',
    (event) => {
      const f = event.target;
      if (!istKorbFormular(f)) return;
      const felder = [...f.querySelectorAll('input[name]')];
      if (f.id) felder.push(...document.querySelectorAll(`input[form="${f.id}"][name]`));
      const weg = felder.filter((el) => istMengenFeld(el.getAttribute('name')));
      weg.forEach((el) => {
        el.dataset.snName = el.getAttribute('name');
        el.removeAttribute('name');
      });
      setTimeout(() => {
        weg.forEach((el) => {
          if (el.dataset.snName) {
            el.setAttribute('name', el.dataset.snName);
            delete el.dataset.snName;
          }
        });
      }, 3000);
    },
    true
  );
  document.addEventListener(
    'formdata',
    (event) => {
      if (!istKorbFormular(event.target)) return;
      for (const k of [...event.formData.keys()]) if (istMengenFeld(k)) event.formData.delete(k);
    },
    true
  );
}
